import React from "react";
import { Text, View } from "react-native";
import tw from "twrnc";

import { colors } from "@/components/settings/theme";
import { ROLE_LABELS } from "./roles";

const TONES = {
  admin: { bg: colors.brandTint, fg: colors.brandPressed },
  editor: { bg: colors.infoTint, fg: colors.info },
  moderator: { bg: colors.surfaceStrong, fg: colors.slate },
  holder: { bg: colors.surfaceStrong, fg: colors.ink },
  pending: { bg: colors.warningTint, fg: colors.warning },
};

// A small label: "Admin", "Editor", "Moderator", or any `text` (e.g. "Invited").
const RolePill = ({ role, text, tone, style }) => {
  const t = TONES[tone || role] || TONES.moderator;
  const label = text || ROLE_LABELS[role] || role;
  if (!label) return null;
  return (
    <View
      style={[
        tw`px-2 py-0.5 rounded-full self-start`,
        { backgroundColor: t.bg },
        style,
      ]}
    >
      <Text
        numberOfLines={1}
        style={[tw`text-[12px] leading-[16px] font-semibold`, { color: t.fg }]}
      >
        {label}
      </Text>
    </View>
  );
};

export default RolePill;
